import { render, staticRenderFns } from "./card-coupons.vue?vue&type=template&id=5a1e77da&scoped=true"
import script from "./card-coupons.vue?vue&type=script&lang=js"
export * from "./card-coupons.vue?vue&type=script&lang=js"
import style0 from "./card-coupons.vue?vue&type=style&index=0&id=5a1e77da&prod&lang=less&scoped=true"
import style1 from "./card-coupons.vue?vue&type=style&index=1&id=5a1e77da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e77da",
  null
  
)

export default component.exports